/* eslint-disable
    import-x/no-mutable-exports,
    no-var,
    one-var,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import * as PoliceableActions from 'collaborator-components/PoliceableActions';
import {assert} from 'Asserts';
import {StandardFeature} from 'auth/capabilities/CapabilityConstants';
import * as ArchiveModal from 'archive/components/modals/ArchiveModal';
import {getArchiveAction, getUnarchiveAction} from 'archive/ArchiveActionsUtil';
import isArchived from 'archive/isArchived';
import isCollaboratable from 'auth/isCollaboratable';
import runModal from 'ui-library/runModal';
import isArchivable from 'archive/isArchivable';
import {RegistryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import * as BenchlingUtil from 'BenchlingUtil';
import preferences from 'Preferences';
import * as RegistryUtil from 'registry/RegistryUtil';
import * as contextmenu from 'components/ContextMenu';
import * as FileBrowserConstants from 'constants/FileBrowserConstants';
import * as SourceActions from 'file-browser/SourceActions';

const {INVENTORY_SECTION, NOTEBOOK_SECTION} = FileBrowserConstants;

import * as ExportConstants from 'constants/ExportConstants';
import * as FolderConstants from 'constants/FolderConstants';
import ModelTypeConstants, {NOTEBOOK_ITEMS, COPYABLE_FOLDER_ITEMS} from 'constants/ModelTypeConstants';
import {getRegistrySupportedTypes} from 'constants/RegistryConstants';
import * as SourceConstants from 'constants/SourceConstants';

const {REGISTRY_TYPE} = SourceConstants;

import ExportModalClass from 'exports/ExportModal';
import FilesForDeleteModalClass from 'folder-items/FilesForDeleteModal';
import normalizeFolder from 'folders/util/normalizeFolder';
import listFolderSection from 'nav/sidepanel/listFolderSection';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import * as SidepanelReduxActions from 'nav/sidepanel/SidepanelReduxActions';
import notifications from 'notifications';
import * as DeleteUtil from 'permissions/DeleteUtil';
import {getStore} from 'redux-stores/Store';
import * as ModalContainer from 'ui-library/ModalContainer';
import RegistryActions from 'registry/RegistryActions';
import * as RegistryValidatorActions from 'registry/RegistryValidatorActions';
import {openSetCollectionModal} from 'registry/SetCollectionModal';
import EntityStore from 'stores/EntityStore';
import copyToClipboard from 'util/clipboard/copyToClipboard';
import APIUtil from 'util/APIUtil';
import * as modals from 'util/Modals';
import * as ShortcutUtil from 'util/ShortcutUtil';
import * as WorkflowActions from 'workflows/WorkflowActions';

import {dispatchRemoveWorklistItems} from 'worklists/WorklistActions';
import EntryDAO from 'dao/EntryDAO';
import CloneModal from 'folder-items/CloneModal';
import FileBrowserActions from './FileBrowserActions';
import FinderUtil from './FinderUtil';
import {confirmUngroupFolder, ungroupFolder} from './FolderActions';
import FolderSelectorModalClass from './FolderSelectorModal';
import {FolderSettingsModalWrapper as FolderSettingsModal} from './FolderSettingsModal';
import HideProjectModalClass from './HideProjectModal';
import {ProjectSettingsModal} from './ProjectSettingsModal';

function _normalizedFolder(file) {
  const apiId = typeof file.id === 'string' ? file.id : file.api_identifier;
  switch (APIUtil.apiIdToType(apiId)) {
    case ModelTypeConstants.FOLDER:
      return {id: apiId, api_identifier: apiId, url: file.url, source: file.source, type: file.type};
    case ModelTypeConstants.SOURCE:
      return FinderUtil.sourceToRootFolder(file);
    default:
      throw new Error('Unable to normalize non-folder type');
  }
}

function _parentFolder(file) {
  switch (APIUtil.apiIdToType(file.id)) {
    case ModelTypeConstants.FOLDER:
      if (file.parent != null) {
        return {
          id: file.parent.api_identifier,
          api_identifier: file.parent.api_identifier,
          url: file.parent.url,
          source: file.parent.source,
          type: file.parent.type,
        };
      } else {
        return null;
      }
    default:
      if (file.folder != null) {
        return {
          id: file.folder.api_identifier,
          api_identifier: file.folder.api_identifier,
          url: file.folder.url,
          source: file.folder.source,
          type: file.folder.type,
        };
      } else {
        return null;
      }
  }
}

function expandFolderOnClick(folder, finderId) {
  SidepanelActions.expand();
  getStore().dispatch(SidepanelReduxActions.listFolder(folder));
}

function getProjectSettingsTooltip(isProject, isProjectArchived) {
  if (isProject && isProjectArchived) {
    return 'Cannot change settings of archived projects.';
  }
  return null;
}

function _makeMenu(list, {file, isListing, finderId, handleQuickEdit}) {
  let type = APIUtil.apiIdToType(file.id);
  // If root folder, treat as project.
  if (type === ModelTypeConstants.FOLDER && file.parent == null) {
    type = ModelTypeConstants.SOURCE;
    file = {...file.source, permissions: file.permissions};
  }
  const hasWriteAuth = file.writable || (file.permissions != null ? file.permissions.writable : undefined);
  const hasAppendAuth = file.permissions && file.permissions.appendable;
  const hasArchiveAuth = file.permissions && file.permissions.archivable;
  const hasUnarchiveAuth = file.permissions && file.permissions.unarchivable;
  const hasDeleteAuth = file.permissions && file.permissions.deletable;
  const hasUnregisterAuth = file.permissions && file.permissions.unregisterable;

  const currentUser = EntityStore.currentUser();
  const isSource = type === ModelTypeConstants.SOURCE;
  const isRegistry = isSource && RegistryUtil.isRegistry(file);
  const isShortcut = isSource ? false : ShortcutUtil.shouldShowShortcut(file, finderId);
  let parentFolderId;
  if (isShortcut) {
    parentFolderId = file.projectFolderId;
  } else {
    parentFolderId = _parentFolder(file) ? _parentFolder(file).id : null;
  }
  const parentRegistry = _parentFolder(file) ? _parentFolder(file).source : null;
  const isRegistered = parentRegistry && parentRegistry.sourceType === ModelTypeConstants.REGISTRY;
  const isFolderContainable = APIUtil.isFolderContainable(file.id);

  const isProject = isSource && _normalizedFolder(file).source.sourceType === ModelTypeConstants.PROJECT;
  const isProjectArchived = Boolean(isProject && isArchived(_normalizedFolder(file).source));

  const isFolder = type === ModelTypeConstants.FOLDER;

  const fullMenu = {
    rename: {
      name: 'Rename',
      click() {
        const oldName = file.name;
        modals
          .prompt('Rename', oldName, (value) => value)
          .done((newName) => {
            FileBrowserActions.renameFileWithDataMods(file.id, isRegistered, {
              oldName,
              newName,
              parentFolderId,
              notifyOnSuccess: true,
            });
          });
      },
      disabled: !hasWriteAuth,
      hide: APIUtil.isDataset(file.id) || !isFolderContainable,
    },

    quickEdit: {
      name: 'Edit',
      click() {
        handleQuickEdit(file);
      },
      hide: handleQuickEdit == null || type === ModelTypeConstants.FOLDER || isProject,
    },

    removeFromWorklist: {
      name: 'Remove from worklist',
      click() {
        dispatchRemoveWorklistItems(file.worklistId, [file.id], {
          refreshWorklistItemsSearch: true,
          refreshRecentWorklists: true,
        });
      },
      hide: file.worklistId == null,
    },

    deleteFile: {
      name: 'Delete',
      click() {
        const deleteDescription = (
          <span>
            {`the ${type === ModelTypeConstants.FOLDER ? 'folder' : 'file'} `}
            <strong>{file.name}</strong>
          </span>
        );
        FilesForDeleteModalClass.openForFileDelete({deleteDescription}, [file], finderId);
      },
      disabled: !hasDeleteAuth,
      hide: !isFolderContainable || !BenchlingConfig.ENABLE_DELETE || APIUtil.isDataset(file.id),
      tooltip: hasDeleteAuth ? null : DeleteUtil.getUndeletableTooltipTitle({isArchived: isArchived(file)}),
    },

    deleteProject: {
      name: 'Delete',
      click() {
        const {source} = _normalizedFolder(file);
        FilesForDeleteModalClass.open({
          fileIds: [source.rootFolder.api_identifier],
          doDelete: () =>
            SourceActions.deleteSource(source.id)
              .done((response) => {
                notifications.success(
                  <>
                    Successfully deleted <strong>{source.name}</strong>
                  </>
                );
              })
              .fail(notifications.notifyError),
          deleteDescription: (
            <span>
              the project <strong>{source.name}</strong>
            </span>
          ),
        });
      },
      disabled: !hasDeleteAuth,
      hide: !isProject || !BenchlingConfig.ENABLE_DELETE,
      tooltip: hasDeleteAuth ? null : DeleteUtil.getUndeletableTooltipTitle({isArchived: isProjectArchived}),
    },

    archive: {
      name: 'Archive',
      click() {
        ArchiveModal.open({
          items: [file],
          onArchive: getArchiveAction([file.id]),
          shouldDetectShortcuts: ShortcutUtil.shouldDetectShortcuts(finderId),
        });
      },
      disabled: !hasArchiveAuth,
      hide: !isArchivable(file) || isArchived(file) || isRegistry,
      dataTestAttrs: {component: 'FileMenu', element: 'archive'},
    },

    unarchive: {
      name: 'Unarchive',
      click() {
        getUnarchiveAction([file.id])([file.id], {hasRegisteredItems: isRegistered});
      },
      disabled: !hasUnarchiveAuth,
      hide: !BenchlingConfig.ENABLE_ARCHIVING_V2 || !isArchived(file),
    },

    move: {
      name: 'Move to folder',
      click() {
        let showInventory, showNotebook;

        function callback(folderId, sourceId, tagSchemaId) {
          FileBrowserActions.moveItemsWithDataMods(
            [file.id],
            folderId,
            {
              parentFolderIds: [parentFolderId],
              tagSchemaId,
              hasRegisteredItems: isRegistered,
            },
            () => isShortcut
          );
        }

        if (type === ModelTypeConstants.FOLDER) {
          showInventory = file.type === FolderConstants.Type.INVENTORY;
          showNotebook = file.type === FolderConstants.Type.NOTEBOOK;
        } else {
          // Non-registry non-notebook types need at least one of these to be true in order to
          // allow moving to folders, so pick inventory as the place for all other types.
          showInventory = [...getRegistrySupportedTypes(), ModelTypeConstants.BULK_ASSEMBLY].includes(type);
          showNotebook = NOTEBOOK_ITEMS.includes(type);
        }
        FolderSelectorModalClass.openForMove(
          {
            currentTagSchema: file.tagSchema,
            initialSelectedFolderId: parentFolderId,
            showInventory,
            showNotebook,
          },
          callback
        );
      },
      hide:
        (isRegistered && !isShortcut) ||
        !isFolderContainable ||
        APIUtil.isDataset(file.id) ||
        !isFeatureEnabled({feature: StandardFeature.MOVE, item: file, itemState: {isRegistered}}),
    },

    copy: {
      name: 'Copy to...',
      click() {
        let showInventory, showNotebook;

        function callback(folderId) {
          FileBrowserActions.copyItems([file.id], folderId);
        }

        if (type === ModelTypeConstants.FOLDER) {
          showInventory = file.type === FolderConstants.Type.INVENTORY;
          showNotebook = file.type === FolderConstants.Type.NOTEBOOK;
        } else {
          showInventory = Array.from(getRegistrySupportedTypes()).includes(type);
          showNotebook = Array.from(NOTEBOOK_ITEMS).includes(type);
        }
        // For entries we show a clone modal with entry schema options
        if (APIUtil.isEntry(file.id) && BenchlingConfig.ELN_ENABLE_SCHEMA_ON_ENTRY_CREATE_MODAL) {
          EntryDAO.get(file.id).then((entry) => {
            runModal(CloneModal, {
              modelType: ModelTypeConstants.ENTRY,
              id: entry.id,
              versionId: entry.latestVersionId,
              initialName: `Copy of ${entry.name}`,
            });
          });
        } else {
          FolderSelectorModalClass.openForCopy(
            {
              initialSelectedFolderId: isRegistered ? null : parentFolderId,
              showInventory,
              showNotebook,
            },
            callback
          );
        }
      },
      hide:
        !isFolderContainable ||
        !isFeatureEnabled({feature: StandardFeature.CREATE, item: file, itemState: {isRegistered}}) ||
        (!isFolder && !COPYABLE_FOLDER_ITEMS.includes(APIUtil.apiIdToType(file.id))),
    },

    copyApiId: {
      name: 'Copy API ID',
      click() {
        copyToClipboard(file.id, {showToastOnSuccess: true});
      },
      hide: !preferences.get('ENABLE_COPY_API_ID'),
    },

    ungroup: {
      name: 'Ungroup...',
      click() {
        const folder = normalizeFolder(file);
        assert(APIUtil.apiIdToType(file.id) === ModelTypeConstants.FOLDER, 'File must be a folder');
        assert(_parentFolder(file) != null, 'Folder must have a parent');

        confirmUngroupFolder(folder).done(() => {
          ungroupFolder(folder);
        });
      },
      hide:
        !isFolder ||
        file.hidden ||
        file.archived ||
        _parentFolder(file) == null ||
        !BenchlingConfig.NAV_ENABLE_FOLDER_UNGROUP_TOOL,
    },

    changeCollection: {
      name: 'Change collection...',
      click() {
        return openSetCollectionModal({files: [file]});
      },
      hide: !isRegistered || parentRegistry.disablePersonalCollections || !hasAppendAuth,
    },

    expand: {
      name: 'Expand',
      click() {
        expandFolderOnClick(_normalizedFolder(file), finderId);
      },
      hide: ![ModelTypeConstants.FOLDER, ModelTypeConstants.SOURCE].includes(type),
    },

    register: {
      name: 'Register',
      click() {
        RegistryValidatorActions.openRegistryValidatorModal([file]);
      },
      disabled: !hasWriteAuth,
      hide:
        isRegistered ||
        isShortcut ||
        !(
          APIUtil.isBiologicalEntity(file.id) &&
          isFeatureEnabled({feature: RegistryFeature.REGISTRY_REGISTER})
        ),
    },

    unregister: {
      name: 'Unregister',
      click() {
        function callback(folderId, sourceId, tagSchemaId) {
          RegistryActions.unregisterWithDataMods([file.id], folderId, [parentFolderId]);
        }

        FolderSelectorModalClass.openForMove(
          {
            currentTagSchema: file.tagSchema,
            showInventory: true,
            showNotebook: false,
          },
          callback
        );
      },
      disabled: !hasUnregisterAuth,
      hide:
        (!isRegistered && !isShortcut) || !isFeatureEnabled({feature: RegistryFeature.REGISTRY_UNREGISTER}),
    },

    openEnclosingFolder: {
      name: 'Open enclosing folder',
      async click() {
        let folder;
        let section;
        if (isShortcut) {
          folder = await ShortcutUtil.projectFolder(parentFolderId);
          if (folder == null) {
            // If we don't have access to project folder, open original parent folder
            folder = _parentFolder(file);
          }
        } else {
          folder = _parentFolder(file);
        }
        folder = _normalizedFolder(folder);
        if (type === ModelTypeConstants.FOLDER) {
          section = FolderConstants.FolderSection.ALL;
        } else {
          section = APIUtil.isBiologicalEntity(file.id) ? INVENTORY_SECTION : NOTEBOOK_SECTION;
        }
        listFolderSection(folder, section);
      },
      hide: parentFolderId == null || isListing,
    },

    addToWorkspace: {
      name: 'Open',
      click() {
        FileBrowserActions.openFile(file.id, {
          open: true,
        });
      },
      hide:
        [ModelTypeConstants.FOLDER, ModelTypeConstants.SOURCE, ModelTypeConstants.WORKFLOW].includes(type) ||
        !isFeatureEnabled({feature: StandardFeature.OPEN, item: file, itemState: {isRegistered}}),
    },
    openWorkflow: {
      name: 'Open',
      click() {
        WorkflowActions.routeToWorkflow(file.id);
      },
      hide: type !== ModelTypeConstants.WORKFLOW,
    },
    settings: {
      name: 'Settings',
      click() {
        switch (type) {
          case ModelTypeConstants.FOLDER:
            ModalContainer.open(
              FolderSettingsModal,
              <FolderSettingsModal
                folderId={file.id}
                onRequestClose={function () {
                  return ModalContainer.close(FolderSettingsModal);
                }}
                isReadOnly={!(file.permissions?.writable ?? true)}
              />
            );
            break;
          case ModelTypeConstants.SOURCE:
            if (file.sourceType === REGISTRY_TYPE) {
              BenchlingUtil.navigate(
                null,
                RegistryUtil.getRegistrySettingsUrl(file.s_owner.url_identifier, file.id)
              );
            } else {
              const permissions = _normalizedFolder(file).source.permissions;
              ModalContainer.open(
                ProjectSettingsModal,
                <ProjectSettingsModal
                  permissions={permissions}
                  sourceId={_normalizedFolder(file).source.id}
                  onRequestClose={function () {
                    return ModalContainer.close(ProjectSettingsModal);
                  }}
                />
              );
            }
            break;
          default:
            throw new Error(`Unable to manage settings of a file of type ${type}`);
        }
      },
      hide: ![ModelTypeConstants.FOLDER, ModelTypeConstants.SOURCE].includes(type),
      disabled: ![ModelTypeConstants.FOLDER, ModelTypeConstants.SOURCE].includes(type),
      tooltip: getProjectSettingsTooltip(isProject, isProjectArchived),
      dataTestAttrs: {component: 'FileMenu', element: 'settings'},
    },

    export: {
      name: 'Export',
      click() {
        if (type === ModelTypeConstants.SOURCE && file.sourceType === REGISTRY_TYPE) {
          ExportModalClass.open({
            exportType: ExportConstants.TYPE.REGISTRY,
            registry: file,
          });
          return;
        }
        ExportModalClass.open({folderIds: [_normalizedFolder(file).id]});
      },
      hide:
        !BenchlingConfig.ENABLE_EXPORTS ||
        ![ModelTypeConstants.FOLDER, ModelTypeConstants.SOURCE].includes(type),
      disabled: currentUser == null,
      dataTestAttrs: {component: 'FileMenu', element: 'export'},
    },

    hide: {
      name: 'Hide',
      click() {
        const folder = _normalizedFolder(file);

        ModalContainer.open(
          HideProjectModalClass,
          <HideProjectModalClass
            initialFolders={[folder]}
            onRequestClose={function () {
              ModalContainer.close(HideProjectModalClass);
            }}
          />
        );
      },
      hide: !isProject || file.hidden || file.archived,
      disabled: currentUser == null,
    },

    unhide: {
      name: 'Unhide',
      click() {
        return FileBrowserActions.unhideSource(_normalizedFolder(file).source.id);
      },
      hide: !isProject || !(file.hidden || file.archived),
      disabled: currentUser == null || file.archived,
      tooltip: currentUser != null && file.archived ? 'Archived projects are hidden for all users.' : null,
    },

    manageAccess: {
      name: 'Manage access',
      click() {
        switch (type) {
          case ModelTypeConstants.SOURCE: {
            const source = _normalizedFolder(file).source;
            SourceActions.openSavingCollaborationManagementModal(source);
            break;
          }
          case ModelTypeConstants.FOLDER: {
            PoliceableActions.openSavingCollaborationManagementModal(_normalizedFolder(file).id);
            break;
          }
          default:
            PoliceableActions.openSavingCollaborationManagementModal(file.id);
        }
      },
      hide: !(isCollaboratable(isFolder ? _normalizedFolder(file) : file) || isProject),
      disabled: currentUser == null,
      dataTestAttrs: {component: 'FileMenu', element: 'manageAccess'},
    },

    '-': '-',
  };
  return Array.from(list).map((option) => fullMenu[option]);
}

var FileMenu = {
  _getMenu(options) {
    const list = [
      'expand',
      'openEnclosingFolder',
      'addToWorkspace',
      'openWorkflow',
      '-',
      'move',
      'copy',
      'ungroup',
      'changeCollection',
      'register',
      'unregister',
      'removeFromWorklist',
      '-',
      'rename',
      'quickEdit',
      'deleteFile',
      'deleteProject',
      'archive',
      'unarchive',
      '-',
      'settings',
      'manageAccess',
      'export',
      'hide',
      'unhide',
      '-',
      'copyApiId',
    ];
    return _makeMenu(list, options);
  },

  open(e, options) {
    const menu = FileMenu._getMenu(options);
    const opened = contextmenu.view.open(e.nativeEvent, menu);
    if (opened && options.closeCallback != null) {
      contextmenu.view.once('close', options.closeCallback);
    }
  },
};

export default FileMenu;
